import { z } from "zod";

import UserRefByIdSchema from "@/areas/directory/schemas/UserRefByIdSchema";

const AssignAuditRegistrySchema = z
  .object({
    id: z.string().uuid({ message: "Id is required." }),
    assignedTo: UserRefByIdSchema,
  })
  .strict();

export default AssignAuditRegistrySchema;
